import { Link } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { heroSlides } from '@/mocks/homeData';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const slide = heroSlides[current];

  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="container-custom w-full">
          <div className="max-w-2xl">
            <h1 className="font-serif text-3xl md:text-5xl font-bold text-white mb-4 leading-tight text-balance">
              {slide.title}
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-8">
              {slide.subtitle}
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <Link
                to={slide.link}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-play-fill"></i>
                立即观看
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white rounded-lg font-medium text-sm backdrop-blur-sm transition-all whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all ${
              i === current ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`幻灯片 ${i + 1}`}
          />
        ))}
      </div>

      <button
        onClick={() => setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm text-white rounded-full transition-all"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm text-white rounded-full transition-all"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </section>
  );
}